import { Component, OnInit, ViewChild, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, AlertController, IonSearchbar } from '@ionic/angular/lazy';
import { APIService } from 'src/app/services/api.service';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { ObserverService } from 'src/app/services/observer.service';
import { PersonAddPage } from 'src/app/modals/person-add/person-add.page';
import { PermissionService } from 'src/app/services/permission.service';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-person-picker',
    templateUrl: './person-picker.page.html',
    styleUrls: ['./person-picker.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PersonPickerPage implements OnInit {

    @ViewChild('search_bar_input', { static: false }) search_bar_input: IonSearchbar;

    loading = false;
    params = {};
    all_people = null;
    visible_people = null;
    people = null;
    query = '';
    @Input() person_id = null;
    person = null;
    @Input() invoked_from = null;
    modal_css_class = '';

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private observerService: ObserverService,
        private authService: AuthService,
        private apiService: APIService,
        private router: Router,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
        }

        if(this.person_id) {

            
            this.loadPerson(this.person_id).then((person) => {
                this.person = person;
            })
            .catch(() => { });

        }

        this.loadPeople().catch(() => { });

        this.observerService.subscribe('person_added|person_picker_modal', (person) => {
            if(person) {
                this.all_people.push(person);
                let query = this.query.toLowerCase().trim();
                if(query.length) {
                    if(
                        (person.full_name && person.full_name.toLowerCase().includes(query)) ||
                        (person.number && person.number.toString().includes(query)) ||
                        (person.email_address && person.email_address.toLowerCase().includes(query)) ||
                        (person.mobile_phone_number && person.mobile_phone_number.toString().toLowerCase().includes(query)) ||
                        (person.work_phone_number && person.work_phone_number.toString().toLowerCase().includes(query)) ||
                        (person.home_phone_number && person.home_phone_number.toString().toLowerCase().includes(query)) ||
                        (person.organisation?.title && person.organisation?.title.toString().toLowerCase().includes(query))
                    ) {
                        let people = this.visible_people;
                        people.push(person)
                        people.sort((a, b) => {
                            if(a['full_name'].toLowerCase() < b['full_name'].toLowerCase()) { return -1; }
                            if(a['full_name'].toLowerCase() > b['full_name'].toLowerCase()) { return 1; }
                            return 0;
                        });
                        this.visible_people = people;
                    }
                }
            }
        });

        this.observerService.subscribe('person_deleted|person_picker_modal', (person) => {
            if(person) {
                if(this.all_people) {
                    for(let i = 0; i < this.all_people.length; i++) {
                        if(this.all_people[i].id === person["id"]) {
                            this.all_people.splice(i, 1);
                            break;
                        }
                    }
                }
                if(this.visible_people) {
                    for(let i = 0; i < this.visible_people.length; i++) {
                        if(this.visible_people[i].id === person["id"]) {
                            this.visible_people.splice(i, 1);
                            break;
                        }
                    }
                }
            }
        });

        this.observerService.subscribe('person_updated|person_picker_modal', (person) => {
            if(person) {
                if(this.all_people) {
                    for(let i = 0; i < this.all_people.length; i++) {
                        if(this.all_people[i].id === person.id) {
                            this.all_people[i] = person;
                            break;
                        }
                    }
                }
                if(this.visible_people) {
                    for(let i = 0; i < this.visible_people.length; i++) {
                        if(this.visible_people[i].id === person["id"]) {
                            this.visible_people.splice(i, 1);
                            let query = this.query.toLowerCase().trim();
                            if(query.length) {
                                if(
                                    (person.full_name && person.full_name.toLowerCase().includes(query)) ||
                                    (person.number && person.number.toString().includes(query)) ||
                                    (person.email_address && person.email_address.toLowerCase().includes(query)) ||
                                    (person.mobile_phone_number && person.mobile_phone_number.toString().toLowerCase().includes(query)) ||
                                    (person.work_phone_number && person.work_phone_number.toString().toLowerCase().includes(query)) ||
                                    (person.home_phone_number && person.home_phone_number.toString().toLowerCase().includes(query)) ||
                                    (person.organisation?.title && person.organisation?.title.toString().toLowerCase().includes(query))
                                ) {
                                    let people = this.visible_people;
                                    people.push(person)
                                    people.sort((a, b) => {
                                        if(a['full_name'].toLowerCase() < b['full_name'].toLowerCase()) { return -1; }
                                        if(a['full_name'].toLowerCase() > b['full_name'].toLowerCase()) { return 1; }
                                        return 0;
                                    });
                                    this.visible_people = people;
                                }
                            }
                            break;
                        }
                    }
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("person_added|person_picker_modal");
        this.observerService.destroy("person_deleted|person_picker_modal");
        this.observerService.destroy("person_updated|person_picker_modal");
    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        if(!this.person) {
            setTimeout(() => {
                if(this.search_bar_input) {
                    this.search_bar_input.setFocus();
                }
            }, 200);
        }
    }

    searchPeople() {
        let query = this.query.toLowerCase().trim();
        this.people = null;
        if(query.length) {
            let people = [];
            for(let i = 0; i < this.all_people.length; i++) {
                if(
                    (this.all_people[i].full_name && this.all_people[i].full_name.toLowerCase().includes(query)) ||
                    (this.all_people[i].number && this.all_people[i].number.toString().includes(query)) ||
                    (this.all_people[i].email_address && this.all_people[i].email_address.toLowerCase().includes(query)) ||
                    (this.all_people[i].mobile_phone_number && this.all_people[i].mobile_phone_number.toString().toLowerCase().includes(query)) ||
                    (this.all_people[i].work_phone_number && this.all_people[i].work_phone_number.toString().toLowerCase().includes(query)) ||
                    (this.all_people[i].home_phone_number && this.all_people[i].home_phone_number.toString().toLowerCase().includes(query)) ||
                    (this.all_people[i].organisation?.title && this.all_people[i].organisation?.title.toString().toLowerCase().includes(query))
                ) {
                    if(!this.all_people[i].full_name) {
                        this.all_people[i].full_name = '';
                    }
                    people.push(this.all_people[i]);
                }
            }
            people.sort((a, b) => {
                if(a['full_name'].toLowerCase() < b['full_name'].toLowerCase()) { return -1; }
                if(a['full_name'].toLowerCase() > b['full_name'].toLowerCase()) { return 1; }
                return 0;
            });
            this.people = people;
            this.showInitialVisiblePeople();
        }
        else {
            this.people = [];
        }
    }

    showInitialVisiblePeople() {
        return new Promise<void>((resolve, reject) => {
            this.visible_people = [];
            for(let i = 0; i < 20; i++) {
                if(this.people.length > i) {
                    this.visible_people.push(this.people[i]);
                } 
                else {
                    break;
                }
            }
            resolve();
        });
    }

    showMoreVisiblePeople(event) {
        let count = this.visible_people.length;
        for(let i = 0; i < 20; i++) {
            let position = i + count;
            if(this.people.length > position) {
                this.visible_people.push(this.people[position]);
            } 
            else {
                break;
            }
        }
        event.target.complete();
    }

    loadPerson(person_id) {
        return new Promise<void>((resolve, reject) => {
            this.person = null;
            this.authService.isLoggedIn().then(() => {
                this.apiService.getPerson(person_id).then((person: any) => {
                    if(person) {
                        resolve(person);
                    }
                })
                .catch((error) => {
                    this.person = {};
                    if(error.status == 400) {
                        this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to retrieve a person.");
                    }
                    else if(error.status == 403) {
                        this.presentAlert("Insufficient permissions", "You don't have permission to view a person.");
                    }
                    else if(error.status == 404) {
                        this.presentAlert("Unavailable", "Unfortunately we're unable to retrieve a person at this time.");
                    }
                    else if(error.status == 0) {
                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    loadPeople() {
        return new Promise<void>((resolve, reject) => {
            this.all_people = null;
            this.authService.isLoggedIn().then(() => {
                this.apiService.getPeople(Object.assign({fields:'id,full_name,number,email_address,organisation.title,mobile_phone_number,work_phone_number,home_phone_number'}, {archived: false})).then((people: []) => {
                    if(people) {
                        this.all_people = people;
                    }
                    resolve();
                })
                .catch(error => {
                    this.people = [];
                    if(error.status == 400) {
                        this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to retrieve a list of people.");
                    } 
                    else if(error.status == 403) {
                        this.presentAlert("Insufficient permissions", "You don't have permission to view people.");
                    } 
                    else if(error.status == 404) {
                        this.presentAlert("Unavailable", "Unfortunately we're unable to retrieve a list of people at this time.");
                    }
                    else if(error.status == 0) {
                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    clear() {
        this.person = null;
        setTimeout(() => {
            if(this.search_bar_input) {
                this.search_bar_input.setFocus();
            }
        }, 200);
    }

    close() {
        if(this.person_id && !this.person && !this.params["person_id"]) {
            this.params["picker_action"] = "person_deleted";
            this.modalController.dismiss(this.params);
        }
        else if(this.params["person_id"]) {
            this.params["picker_action"] = "person_selected";
            this.modalController.dismiss(this.params);
        }
        else {
            this.modalController.dismiss();
        }
    }

    select(person_id) {

        this.params["person_id"] = person_id;

        for(let i = 0; i < this.people.length; i++) {
            if(this.people[i].id == person_id) {
                if(this.people[i].full_name) {
                    this.params['person_name'] = this.people[i].full_name + ' (#' + this.people[i].number + ')';
                }
                else {
                    this.params['person_name'] = '#' + this.people[i].number;
                }
                break;
            }
        }

        this.close();
    }

    async presentAddPersonModal() {
        const modal = await this.modalController.create({
            component: PersonAddPage,
            cssClass: this.modal_css_class,
            componentProps: {
                invoked_from: "person_picker_modal"
            }
        });
        modal.onDidDismiss().then((data) => {
            if(data.data) {
                let person_id = data.data['person_id'];
                this.loadPerson(person_id).then((person) => {
                    this.params["person_id"] = person['id'];
                    if(person['full_name']) {
                        this.params['person_name'] = person['full_name'] + ' (#' + person['number'] + ')';
                    }
                    else {
                        this.params['person_name'] = '#' + person['number'];
                    }
                    this.close();
                })
                .catch(() => { });
            }
        });
        return await modal.present();
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

}
